import React, { useState, useEffect } from 'react';
import AdminGarageList from '../components/garage_list/AdminGarageList'
import { useSelector } from 'react-redux';
import axios from 'axios';

export default function AdminGarages() {
    const userUID = useSelector(state => state.user.uid);
    const [garage, setGarage] = useState()
    const [showDiv, setShowDiv] = useState(false);
    useEffect(() => {
        if (userUID !== 'none') {
            axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetGarages', ownerID: 'admin' })
                .then(response => {
                    setGarage(response.data.data);
                    console.log("response", response.data.data)
                })
                .catch(error => {
                    setShowDiv(true);
                    console.error('Error fetching data:', error);
                });
        }

        // const timer = setTimeout(() => {
        //     setShowDiv(true);
        // }, 1200);
    }, [userUID]);

    return (
        <section className="page-content sec-padding">
            <div className="container-fluid">
                <div className="page-content-details">
                    <div className="sec-title row">
                        <div className="col-md-6 text-start">
                            <h3>Garages</h3>
                        </div>
                    </div>
                    <div className='row'>
                        {garage ? <AdminGarageList garagesList={garage} actions={{ delete: true, edit: true, comingsoon: true }}></AdminGarageList> :
                            showDiv && <div className='typewriter '>No Garages</div>}
                    </div>
                </div>
            </div>
        </section>
    );
}